module.exports = "pegasus_template/assets/themelp1/large/2.png";